import { TOGGLE_POPUP } from '../popupConstants';
export const togglePopup = ({ close, popupType }) => ({
    type: TOGGLE_POPUP,
    close,
    popupType,
});
export default togglePopup;
